/* Project Basel - cart add-ons, complete-the-set, dialogs */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function addToCart(items) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to bag');
        if (drawer && drawer.renderContents) {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(res.json);
        } else {
          window.location.href = root + 'cart';
        }
        return res.json;
      });
  }

  document.addEventListener('click', function (e) {
    // Cart drawer add-on
    var add = e.target.closest('[data-pb-add]');
    if (add) {
      e.preventDefault();
      add.setAttribute('aria-busy', 'true');
      addToCart([{ id: Number(add.getAttribute('data-pb-add')), quantity: 1 }]).catch(function (err) {
        add.removeAttribute('aria-busy');
        add.textContent = 'Sold out';
        console.error(err);
      });
      return;
    }

    // Dialog open / close
    var opener = e.target.closest('[data-pb-dialog-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-pb-dialog-open'));
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    var closer = e.target.closest('[data-pb-dialog-close]');
    if (closer) { closer.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('pb-dialog')) e.target.close();
  });

  // Complete the set
  function initSet(el) {
    var btn = el.querySelector('[data-pb-set-add]');
    var msg = el.querySelector('[data-pb-set-msg]');
    var productForm = document.querySelector('product-form form, form[action*="/cart/add"]');

    function currentVariantId() {
      var input = productForm && productForm.querySelector('[name="id"]');
      return input ? Number(input.value) : Number(el.getAttribute('data-current-variant'));
    }

    // Match the other pieces to the size picked on the main product.
    // If that size is sold out in another piece, ask for a size rather than guessing one.
    function syncSizes() {
      var picked = document.querySelector('variant-selects input[type="radio"]:checked, variant-selects select');
      if (!picked) return;
      var size = (picked.value || '').toLowerCase();
      el.querySelectorAll('select[data-pb-set-variant]').forEach(function (sel) {
        if (sel.dataset.touched) return;
        var placeholder = sel.querySelector('option[value=""]');
        var match = Array.prototype.filter.call(sel.options, function (o) {
          return o.value && o.text.toLowerCase().split(' - ')[0].trim() === size;
        })[0];
        if (match && !match.disabled) {
          if (placeholder) placeholder.remove();
          sel.value = match.value;
          sel.classList.remove('pb-set__select--needs');
        } else if (match && match.disabled) {
          if (!placeholder) {
            placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.textContent = 'Size?';
            sel.insertBefore(placeholder, sel.firstChild);
          }
          sel.value = '';
          sel.classList.add('pb-set__select--needs');
        }
      });
    }
    el.querySelectorAll('select[data-pb-set-variant]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        sel.dataset.touched = '1';
        sel.classList.toggle('pb-set__select--needs', !sel.value);
      });
    });
    document.addEventListener('change', function (e) { if (e.target.closest('variant-selects')) setTimeout(syncSizes, 50); });
    syncSizes();

    btn.addEventListener('click', function () {
      msg.textContent = '';
      var missing = el.querySelector('select[data-pb-set-variant].pb-set__select--needs');
      if (missing) {
        msg.textContent = 'Your size is sold out in ' + missing.getAttribute('data-name') + '. Pick another size.';
        missing.focus();
        return;
      }
      var items = [{ id: currentVariantId(), quantity: 1 }];
      el.querySelectorAll('[data-pb-set-variant]').forEach(function (f) { items.push({ id: Number(f.value), quantity: 1 }); });
      btn.setAttribute('aria-busy', 'true');
      addToCart(items)
        .catch(function (err) { msg.textContent = err.message; })
        .then(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  // Header turns solid as soon as the page is scrolled (used by the hero overlay CSS)
  function markScroll() { document.documentElement.classList.toggle('pb-scrolled', (window.scrollY || window.pageYOffset) > 8); }
  window.addEventListener('scroll', markScroll, { passive: true });
  markScroll();

  function boot() { document.querySelectorAll('[data-pb-set]').forEach(initSet); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
